import { api } from '@/config/api';
export interface UserRow { _id: string; userUid: string; email: string; firstName: string; lastName: string; role: string; status: string; companyUid: string; company?: { name: string }; createdAt: string; }
export const usersService = {
  list: async (q: { q?: string; companyUid?: string; page?: number; limit?: number } = {}) =>
    (await api.get('/super_admin/users', { params: q })).data as { items: UserRow[]; total: number; page: number; limit: number },
};
